'use strict';

function CompanyTaskService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/reminders/:taskId', {}, {
    "update": {
      method: "PUT"
    },
    'queryCategories': {
      url: config.apiBase + '/companies/:companyId/reminders/categories',
      method: 'GET',
      isArray: true
    },
    'updateCategories': {
      url: config.apiBase + '/companies/:companyId/reminders/categories',
      method: 'PUT',
      isArray: true
    }
  });
}

angular.module('dokiv')
  .factory('CompanyTaskService', [
    '$resource',
    'config',
    CompanyTaskService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/tasks/CompanyTaskService.js
// module id = 43
// module chunks = 0